/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import * as yup from "yup";
import {
  commissionType,
  deliveryMethod,
} from "../../../../../utils/helpers/objectHelpers";
import { findCustomer } from "../../../../../utils/services/cashierbeneficiary.service";
import { RemittanceService } from "../../../../../utils/services/remittance.service";

function Fees({ countries, currency, dictionary }) {
  const formRef = useRef();
  const menuPortalTarget = document.getElementById("root");
  const [approveAccountOnExecution, setApproveAccountOnExecution] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [eyeOpen, setEyeOpen] = useState(false);
  const [result, setResult] = useState([]);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const toggleCheckBox = () =>
    setApproveAccountOnExecution(!approveAccountOnExecution);

  const schema = yup
    .object({
      currencyCode: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
          currencyCode: yup.string(),
        })
        .required(),
      country: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      delivery: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      commissionType: yup
        .object()
        .shape({ label: yup.string(), value: yup.string() })
        .required(),
      currentBalance: yup.number().required(),
      password: yup.string().required(),
      customer: yup
        .object()
        .shape({ label: yup.string(), value: yup.string() })
        .required(),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const payload = {
      password: data?.password,
      rateType: data?.commissionType?.value,
      country: data?.country?.label,
      currencyCode: data?.currencyCode?.currencyCode,
      supportedFeeType: data?.delivery?.value || "AIRTIME_TOPUP",
      isInclusive: approveAccountOnExecution,
      charge: data?.currentBalance,
      userId: result?.value,
    };
    try {
      const response = await RemittanceService.addFixedAmountFee(payload);

      if (response.status === 200) {
        toast.success("");
        reset({
          currencyCode: {
            iso3Code: "",
            label: "",
            value: "",
            currencyCode: "",
          },
          country: {
            iso3Code: "",
            label: "",
            value: "",
          },
          delivery: {
            label: "",
            value: "",
          },
          commissionType: {
            label: "",
            value: "",
          },
          currentBalance: 0,
          password: "",
          customer: {
            label: "",
            value: "",
          },
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const promiseOptions = async (inputValue) => {
    try {
      const response = await findCustomer(inputValue);
      if (response?.data?.status === "SUCCESS") {
        const res = response?.data?.data?.customers;
        const a = res?.map((i) => {
          return { label: `${i.firstName} ${i.lastName}`, value: i.id };
        });
        return [...a];
      }
    } catch (error) {
      return [];
    }
  };

  return (
    <form
      className="needs-validation"
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete={"off"}
    >
      <div className="form-row">
        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary
              ? dictionary["WO_CUSTOMERSEARCH_PHON_973941510"]
              : "Customer(search Phone, email, name, customer reference no)"}
            <span style={{ color: "red" }}> *</span>
          </label>
          <AsyncSelect
            cacheOptions
            loadOptions={promiseOptions}
            isClearable={false}
            isSearchable={true}
            maxMenuHeight={250}
            placeholder="Enter customer details..."
            menuPlacement="bottom"
            menuPortalTarget={menuPortalTarget}
            onChange={(option) => {
              setResult(option);
            }}
          />
        </div>

        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary
              ? dictionary["para_delivery_method"]
              : "Delivery Method"}
            <span style={{ color: "red" }}> *</span>
          </label>
          <Controller
            name="delivery"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={deliveryMethod()}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>

        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary
              ? dictionary["WO_SELECT_CURRENCY_COD_-1563592345"]
              : "Select Currency Code"}
            <span style={{ color: "red" }}> *</span>
          </label>
          <Controller
            name="currencyCode"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={currency}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>

        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary
              ? dictionary["WO_TRANSACTION_ORIGINAT_796479975"]
              : "Transaction Originating Country"}
            <span style={{ color: "red" }}> *</span>
          </label>
          <Controller
            name="country"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={countries}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>

        <div className="col-md-6 col-lg-6 mb-3">
          <div className="form-row">
            <div className="col-md-6 col-lg-6">
              <label>
                {dictionary
                  ? dictionary["para_charges_type"]
                  : "Commission Type"}
              </label>
              <Controller
                name="commissionType"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={commissionType}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
            <div className="col-md-6 col-lg-6">
              <label>
                {dictionary ? dictionary["WO_AMOUN_1657560372"] : "Amount"}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="currentBalance"
                {...register("currentBalance", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-6 mb-3 position-relative">
          <label>
            {dictionary ? dictionary["WO_PASSWOR_-1150637439"] : "Password"}
          </label>
          <input
            type={passwordShown ? "text" : "password"}
            className="form-control border px-3"
            name="password"
            {...register("password", {
              required: {
                value: true,
                message: "This field is required",
              },
            })}
          />
          {!eyeOpen ? (
            <i
              className="fa fa-eye-slash position-absolute"
              style={{ top: "43%", right: "5%", cursor: "pointer" }}
              onClick={() => {
                setEyeOpen(!eyeOpen);
                togglePasswordVisiblity();
              }}
            />
          ) : (
            <i
              className="fa fa-eye position-absolute"
              style={{ top: "43%", right: "5%", cursor: "pointer" }}
              onClick={() => {
                setEyeOpen(!eyeOpen);
                togglePasswordVisiblity();
              }}
            />
          )}
          <div className="form-row m-0">
            <label className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                defaultChecked={false}
                onChange={toggleCheckBox}
              />
              <span className="custom-control-label pointer fs-12">
                <span>
                  {" "}
                  {dictionary
                    ? dictionary["WO_CHARGES_INCLUSIVE_IN_-1545297777"]
                    : " Charges inclusive in sending amount"}
                </span>
              </span>
            </label>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 mb-3" />
        <div className="col-lg-6 col-md-6 mb-3">
          <button
            className="btn btn-primary margin-label width-100 fw-bold text-uppercase"
            type="submit"
          >
            {dictionary ? dictionary["WO_SAVE_-91866246"] : "SAVE"}
            {loading && (
              <>
                &nbsp;
                <i className="fa fa-spinner fa-spin" />
              </>
            )}
          </button>
        </div>
      </div>
    </form>
  );
}

export default Fees;
